export class Route_eCMRConditionsDto {
	public conditions: string;
	public reset: boolean;

	public static buildReset(): Route_eCMRConditionsDto {
		let result: Route_eCMRConditionsDto = new Route_eCMRConditionsDto();
		result.reset = true;
		return result;
	}

	public static build(conditions: string): Route_eCMRConditionsDto {
		let result: Route_eCMRConditionsDto = new Route_eCMRConditionsDto();
		result.conditions = conditions;
		return result;
	}
}
